import React from 'react'
import { connect as connectRedux } from 'react-redux'
import compose from 'recompose/compose'
import { List, Map } from 'immutable'
import _compact from 'lodash/compact'
import {
  createUpstreamContext,
  SCREEN_TYPE_MEMBER_HOME,
  updateUpstreamContext,
  CONTEXT_NAME_ADMIN_TITLE,
} from '../../../services/upstream-context/index'
import { getBoundActions } from '../../../actions/index'
import {
  ROW_IMPRESSION_GA4_EVENT,
} from '../../../services/event-tracking/index'
import {
  getPmSectionTabs,
  MAX_ROW_ITEMS,
  UI_LOCATION_MEMBER_HOME,
  pmSectionTabsHaveData,
} from '../../../services/pm-section/index'
import { getUserLanguagePrimary } from '../../../services/user/index'
import { EN } from '../../../services/languages/constants'
import {
  selectVideos,
  selectSeries,
  selectTerms,
} from '../../../services/node/index'
import TileV2GraphqlManager from '../../Tile.v2GraphqlManager/index'
import { createTitleGroupId } from '../../../services/content/index'
import { H4 } from '../../Heading/index'

const CONTEXT_TYPE_EXPLORE_BY_TOPIC_LIST = 'pm/explore-by-topic-list'
const HEADER_LABEL_EXPLORE_BY_TOPIC = 'explore by topic'

class SectionExploreByTopicV2 extends React.Component {
  constructor (props) {
    super(props)
    const {
      sectionId,
      sectionIndex,
    } = props

    const upstreamContext = createUpstreamContext({
      screenType: SCREEN_TYPE_MEMBER_HOME,
      contextType: CONTEXT_TYPE_EXPLORE_BY_TOPIC_LIST,
      sectionId,
      sectionIndex,
      headerLabel: HEADER_LABEL_EXPLORE_BY_TOPIC,
    })

    this.isVisible = false
    this.rowSeen = {}
    this.visibleIndexes = []
    this.state = {
      upstreamContext,
    }
    this.indexes = []
    this.itemsData = List()
  }

  onRenderContent = (indexes) => {
    this.visibleIndexes = indexes
    this.checkAndSendImpressionGAEvent()
  }

  onVisibilityChange = (isVisible, index, itemsData) => {
    this.isVisible = isVisible
    this.itemsData = itemsData || List()
    this.checkAndSendImpressionGAEvent(index)
  }

  checkAndSendImpressionGAEvent = (index) => {
    const {
      isVisible,
      props,
      rowSeen,
      itemsData,
      visibleIndexes,
    } = this
    const {
      hasChildData,
      setEventDefault,
      adminTitle,
      sectionIndex = null,
      rowPlacement = null,
      section,
    } = props

    if (isVisible && hasChildData) {
      if (!rowSeen[index]) {
        const infoArray = visibleIndexes
          .map((itemIndex) => {
            const item = itemsData.get(itemIndex)
            return item ? `${item.get('contentId')} | ${item.get('title')}` : null
          })
          .filter((item) => item !== null)
          .join(' | ')

        const eventDataGA4 = ROW_IMPRESSION_GA4_EVENT
          .mergeDeep({
            row_placement: rowPlacement,
            row_name: adminTitle,
            row_number: sectionIndex,
            row_type: section.getIn(['data', 'type']),
            visible_tiles: visibleIndexes,
            visibility_rules: section.getIn(['data', 'visibility']),
            content_info_array: infoArray,
            ui_location: UI_LOCATION_MEMBER_HOME,
          })
        rowSeen[index] = true
        setEventDefault(eventDataGA4)
      }
    }
  }

  renderContentRow = (item, index) => {
    const {
      props,
      state,
    } = this
    const {
      upstreamContext,
    } = state
    const {
      adminTitle,
      language,
    } = props
    const itemContent = item.get('tabContent', List()) || List()
    const items = itemContent.slice(0, MAX_ROW_ITEMS)
    const titleGroupIds = _compact(items.reduce((acc, contentItem) => {
      return acc.push(createTitleGroupId(contentItem.get('contentId'), contentItem.get('contentType')))
    }, List()).toJS()) || []

    return (
      <div key={`topic-${index}-${item.get('tabLabel', '')}`} className="section-topics__row">
        <div className="section-topics__header">
          <H4 className="section-topics__row-title">
            {item.get('tabLabel')}
          </H4>
        </div>
        {
          titleGroupIds.length
            ? <TileV2GraphqlManager
                {...props}
                onRenderContent={this.onRenderContent}
                onVisibilityChange={(isVisible, itemsData) => {
                  this.onVisibilityChange(isVisible, index, itemsData)
                }}
                titleGroupIds={titleGroupIds}
                adminTitle={adminTitle}
                upstreamContext={updateUpstreamContext(
                  upstreamContext,
                  CONTEXT_NAME_ADMIN_TITLE,
                  adminTitle,
                )}
                language={language}
              />
            : null
        }
      </div>
    )
  }

  renderContent = () => {
    const {
      props,
      renderContentRow,
    } = this
    const {
      topicsList,
    } = props

    return (
      <div className="section-topics__content">
        {
          topicsList.map((item, index) => renderContentRow(item, index))
        }
      </div>
    )
  }

  render () {
    const {
      props,
      renderContent,
    } = this
    const {
      hasData,
      topicsList,
      sectionId,
    } = props

    // Don't render anything if we have data, but the data has no topics
    if (hasData && topicsList.size === 0) {
      return null
    }

    return (
      <div
        className="section-topics"
        data-page-manager-section-id={sectionId}
      >
        <div className="section-topics__outer-wrapper">
          {hasData ? renderContent() : <div className="section-topics__rows" />}
        </div>
      </div>
    )
  }
}

export default compose(
  connectRedux(
    (state, ownProps) => {
      const { sectionId } = ownProps
      const {
        auth,
        pmSection,
        user,
        staticText,
      } = state
      const section = pmSection.get(sectionId)
      const tabs = getPmSectionTabs({ sectionId, pmSection })
        .filter((tab) => !tab.get('tabContent', List()).isEmpty())
      const language = getUserLanguagePrimary(user) || EN
      const videos = selectVideos(state)
      const series = selectSeries(state)
      const term = selectTerms(state)
      const hasChildData = pmSectionTabsHaveData({
        tabs,
        videos,
        series,
        term,
        language,
        tabContentMaxItems: MAX_ROW_ITEMS,
      })
      return {
        staticText: staticText.getIn(['data', 'sectionExploreByTopic', 'data'], Map()),
        auth,
        language,
        sectionId,
        section,
        adminTitle: section.getIn(['data', 'adminTitle']),
        hasData: section.has('data'),
        processing: section.get('processing', false),
        topicsList: tabs,
        hasChildData,
        videoStore: (hasChildData && videos) || Map(),
        seriesStore: (hasChildData && series) || Map(),
        showHideContentButton: section.getIn(['data', 'data', 'enableUserHiddenContent']),
      }
    },
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setUpstreamContext: actions.upstreamContext.setUpstreamContext,
        setEventDefault: actions.eventTracking.setEventDefault,
      }
    },
  ),
)(SectionExploreByTopicV2)
